import { render } from "./LivePage.vue?vue&type=template&id=74379f24&ts=true"
import script from "./LivePage.vue?vue&type=script&lang=ts"
export * from "./LivePage.vue?vue&type=script&lang=ts"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__